import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
} from "@mui/material";
import CustomButton from "../../components/Button";
import CustomInput from "../../components/Input";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Colors } from "../../constants/Colors";
import { apiRequest } from "../../services/api-request";
import { useAppContext } from "../../context/AppContext";
import SelectPicker from "../../components/SelectPicker";

const Add = (props) => {
  
  const { isEdit, currentList } = props;

  const { user } = useAppContext();

  const [statesList, setStatesList] = useState([]);

  const schema = yup
    .object({
      name: yup.string().required("Name is required"),
      selectState: yup.string().required("State is required"),
    })
    .required();

  const getEditUserDetails = (isEdit, currentList) => {
    if (!isEdit) {
      return { name: "", selectState:""};
    } else {
      return {
        name: currentList?.name,
        selectState: currentList?.state_id,
      };
    }
  };

  const { handleSubmit, control,  getValues, watch } = useForm({
    resolver: yupResolver(schema),
    defaultValues: getEditUserDetails(isEdit, currentList),
  });

    useEffect(() => {
        getStates();
    }, []);

    const getStates = () => {
        apiRequest({
          url: `master/states`,
          method: "GET",
        })
        .then((res) => {
            const getList = res?.data?.map((elem) => ({
                name: elem?.display_name,
                value: elem?.id,
            }));
            setStatesList(getList);
        })
          .catch((err) => {
            alert(err?.response?.data?.message, "error");
        });
    };

  const onSubmit = (data) => {
    if (isEdit && currentList?.name) {
      const formData = getValues();
      const payload = {
        id: currentList?.id,
        name: data?.name,
        state_id: data?.selectState,
      };
      apiRequest({
        url: `master/add-update-circle-office`,
        data: payload,
        method: "POST",
      })
        .then((res) => {
          props.onClickModalClose(true);
          props.getLists()
          if (res?.success === true) {
            alert("Cirlce Office updated successfully");
          }
          if (res?.success === false) {
            alert(res?.message);
          }
        })
        .catch((err) => {
          alert(err?.response?.data?.message, "error");
        });
    } else {
      const payload = {
        name: data.name,
        state_id: data.selectState,
      };
      apiRequest({
        url: `master/add-update-circle-office`,
        data: payload,
        method: "POST",
      })
        .then((res) => {
          props.onClickModalClose(true);
          props.getLists()
          if (res?.success === true) {
            alert("Cirlce Office added successfully");
          }
          if (res?.success === false) {
            alert(res?.message);
          }
        })
        .catch((err) => {
          console.log(err);
          alert(err?.response?.data?.message, "error");
        });
    }
  };

  return (
    <>
      {props.loader ? (
        <>{"loading"}</>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <Grid
            container
            alignItems={"center"}
            justifyContent={"center"}
            width={"100%"}
            mt={"10px"}
            gap={3}>
            <Grid item width="45%">
              <Controller
                name="name"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <CustomInput
                    {...field}
                    type={"text"}
                    inputLabel={"Enter Cirlce Office Name"}
                    error={!!error}
                    helperText={error ? error.message : ""}
                  />
                )}
              />
            </Grid>

            <Grid item width="45%">
              <Controller
                name="selectState"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <SelectPicker
                    {...field}
                    borderRadius={10}
                    width={300}
                    options={statesList}
                    placeholder={"Select State"}
                    error={!!error}
                    helperText={error ? error?.message : ""}
                  />
                )}
              />
            </Grid>

          </Grid>

          <Grid
            container
            alignItems={"flex-start"}
            justifyContent="center"
            mt={3}
            width={"100%"}
            gap={3}>
            <Grid item width={"45%"}>
              <Box
                display={"flex"}
                alignItems={"end"}
                justifyContent={"flex-end"}
                width={"100%"}
                gap={"12px"}>
                <Box width={"48%"}>
                  <CustomButton
                    variant={"outlined"}
                    title={`Cancel`}
                    handleButtonClick={props.onClickModalClose}
                    backgroundColor={Colors.white}
                    textColor={Colors.headerColor}
                    width={"100%"}
                    height={34}
                    borderColor={Colors.headerColor}
                    textFontSize={14}
                  />
                </Box>
                <Box width={"48%"}>
                  <CustomButton
                    title={`Save`}
                    backgroundColor={Colors.headerColor}
                    textColor={Colors.white}
                    width={"100%"}
                    height={34}
                    borderColor={Colors.headerColor}
                    textFontSize={14}
                    type={"submit"}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </form>
      )}
    </>
  );
};

export default Add;
